import { render, staticRenderFns } from "./ComponentFooter.vue?vue&type=template&id=0b0be74c&scoped=true"
import script from "./ComponentFooter.vue?vue&type=script&lang=ts"
export * from "./ComponentFooter.vue?vue&type=script&lang=ts"
import style0 from "./ComponentFooter.vue?vue&type=style&index=0&id=0b0be74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0be74c",
  null
  
)

export default component.exports